export default __webpack_public_path__ + "static/media/cp1.9e77df24.png";